import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";
import SessionSelector from "CinicComponents/SessionSelector";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import AddSessionsToPackageReq from "../../../../Classes/Models/Requests/AccountingSessions/AddSessionsToPackageReq";
import "./pacakge.scss";
const AddSessionsToPackage = ({ Package }) => {
  const [Session, setSession] = useState({});
  const [Quantity, setQuantity] = useState(1);
  const [OriginalPrice, setOriginalPrice] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [FinalPrice, setFinalPrice] = useState(0);
  const Patient = Package.getPatient;
  var User = { getPatient: Package.getPatient };
  const ShowPricing = () => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      return (
        <MDBox mt={4} mb={1}>
          <MDTypography
            className="patient-national-group-package"
            variant="button"
            fontWeight="regular"
            color="text"
          >
            <div className="single-session-discount">
              <div>
                <span style={{ color: "black" }}>Patient Nationality Group:</span>{" "}
                {Patient.nationalityGroup}
              </div>
              <div>
                <span style={{ color: "black" }}>Original Price:</span> EGP{OriginalPrice}
              </div>
              <div>
                <span style={{ color: "black" }}>Final Price:</span> EGP{FinalPrice}
              </div>
              <div>
                <span style={{ color: "black" }}>Discount:</span> %{Number(Discount).toFixed(1)}
              </div>
              <div>
                <span style={{ color: "black" }}>Total:</span> EGP{FinalPrice * Quantity}
              </div>
            </div>
             
          </MDTypography>
        </MDBox>
      );
    }
  };
  const GetOriginalPrice = () => {
    if (Patient.getUser.nationalityGroup == "Egyptian") {
      setOriginalPrice(Session.egyptianPrice);
    } else if (Patient.getUser.nationalityGroup == "Arab") {
      setOriginalPrice(Session.arabPrice);
    } else if (Patient.getUser.nationalityGroup == "Other") {
      setOriginalPrice(Session.otherPrice);
    } else {
      setOriginalPrice("PRICE NOT FOUND");
    }
  };
  useEffect(() => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      GetOriginalPrice();
    }
  }, [Session, Patient]);
  useEffect(() => {
    setDiscount(((100 * (OriginalPrice - FinalPrice)) / OriginalPrice).toFixed(2));
  }, [Session, Quantity, FinalPrice]);
  const AddSessionsToPackage = async () => {
    Swal.fire({
      title: "Add Session to Package",
      icon: "info",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let req = new AddSessionsToPackageReq();
    req.sessionId = Session.id;
    req.quantity = Quantity;
    req.finalPrice = FinalPrice;
    req.packageId = Package.id;

    let res = await SessionsApi.AddAccountingSessionsToPackage(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Sessions added to package successfully",
        icon: "success",
        confirmButtonText: "OK",
      })
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      })
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  if (!Patient || Object.keys(Patient).length < 1) {
    return (
      <MDBox>
        <MDTypography>Please select a patient</MDTypography>
      </MDBox>
    );
  }
  return (
    <div className="add-session-card">
      <SessionSelector setSession={setSession} Patient={User} />
      <div className="input-container">
        <MDInput
          type={"number"}
          onChange={(e) => setQuantity(parseInt(e.target.value))}
          placeholder={"Enter Quantity"}
        />
        <MDInput
          type={"number"}
          onChange={(e) => setFinalPrice(parseFloat(e.target.value))}
          placeholder={"Enter Final Price"}
        />
        <button className="btn btn-primary " onClick={AddSessionsToPackage}>
          Add Sessions
        </button>
      </div>

      {ShowPricing()}
    </div>
  );
};
export default AddSessionsToPackage;
